import React from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import Input from '../../forms/Input';
import FormSetting from '../../layout/FormSetting';

const Header = ({ ...props }) => {

    return (
        <PageBreak>
            <FormSetting
                label='Invoice/Receipt Header Settings'
                name='AccountHeadersSettings'
                getInputs={QuestRoute.settings.header}
                onSubmit={e => HamQuest.put(QuestRoute.settings.header, { ...e })}
                text='Update'
                editable
            >
                <Input
                    label='Company Name'
                    name='companyName'
                    required
                />

                <Input
                    label='Address'
                    name='address'
                    required
                />

                <Input
                    label='Address 2'
                    name='address2'
                />

                <Input
                    label='City'
                    name='city'
                    required
                />

                <Input
                    label='State'
                    name='stateProvince'
                    required
                />

                <Input
                    label='Zip Code'
                    name='zipPostalCode'
                    required
                />
            </FormSetting>
        </PageBreak >
    );
}

export default Header;